module.exports = __webpack_public_path__ + "media/alert_sound2.6e822aef.mp3";